import type { PolicyConsentPayloadDTO, Profile, ProfileUpdatePayload } from "@/core/types";
import type { AptiRequestConfig } from "@/lib/types/api";
import { httpAuth } from "@/utils/axios";

export type AppendPatientConsentResponse = {
  message: string;
};

export const patientRequestsTyped = {
  append_patient_consent: function ({
    data,
    params,
  }: {
    data: PolicyConsentPayloadDTO;
    params?: Record<string, unknown>;
  }) {
    const config = {
      data,
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: "/v1/patient/append_consent",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AppendPatientConsentResponse>;
  },

  update_profile: function ({ data }: { data: ProfileUpdatePayload }) {
    const config = {
      data,
      method: "POST",
      url: "/v1/patient/update_profile",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<Profile>;
  },
};
